module.exports = __webpack_public_path__ + "static/img/main_point_img09.53811f38.svg";